import React from 'react';

// F28's official icon — "Orbit + Open Dot" (candidate #30).
// Filled dot = the value you last confirmed; the arc carries it forward; the
// hollow dot = the estimated value waiting for you. Purpose-built to stay
// legible down to 16px, so keep it to these three marks.
//
// Same prop shape as lucide-react icons (size / color / strokeWidth), so it
// drops into existing call sites unchanged and inherits currentColor.
const ReviewIcon = ({ size = 24, color = 'currentColor', strokeWidth = 2, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        {...props}
    >
        <circle cx="11" cy="13.2" r="2.4" fill={color} stroke="none" />
        <path d="M4.4 11.2A8.6 8.6 0 0 1 15 6.2" />
        <circle cx="18" cy="5.8" r="2.5" />
    </svg>
);

export default ReviewIcon;
